import React, { createContext, useContext, useState } from 'react'
import { apiDelete, apiGet, apiPatch } from '~/util/api'
const SavedCoursesContext = createContext()

const useSavedCourses = () => {
  return useContext(SavedCoursesContext)
}
export default useSavedCourses

export const SavedCoursesProvider = ({
  saved_courses,
  candidateId,
  indexPath,
  children,
}) => {
  const [courses, setCourses] = useState(saved_courses)
  const [selectedCourse, setSelectedCourse] = useState(null)
  const [showCompletedCourseDialog, setShowCompletedCourseDialog] =
    useState(false)

  const toggleCompletedCourseDialog = () =>
    setShowCompletedCourseDialog((prev) => !prev)

  const openCompletedCourseDialog = (course) => {
    setSelectedCourse(course)
    setShowCompletedCourseDialog(true)
  }

  const reloadCourses = async () => {
    const response = await apiGet(indexPath)
    if (response.status === 200) {
      console.log('response', response)
      setCourses(response.data)
    } else {
      console.error('Error fetching courses:', response)
    }
  }

  const deleteCourse = async (savedCourse) => {
    const { id } = savedCourse
    const response = await apiDelete(`/research_learning/my_courses/${id}`)
    if (response.status === 200) {
      reloadCourses()
    } else {
      console.error('Error updating course:', response)
    }
  }

  const reminderExists = (savedCourse) => {
    const { reminder } = savedCourse
    return reminder
  }

  const updateCourse = async (savedCourse, updates) => {
    const { id } = savedCourse
    const response = await apiPatch(`/research_learning/my_courses/${id}`, {
      saved_course: updates,
    })

    if (response.status === 200) {
      setCourses((prevCourses) =>
        prevCourses.map((course) => {
          if (course.id === id) {
            return { ...course, ...updates }
          }
          return course
        }),
      )
    } else {
      console.error('Error updating course:', response)
    }
  }

  const value = {
    courses,
    updateCourse,
    reminderExists,
    candidateId,
    deleteCourse,
    selectedCourse,
    showCompletedCourseDialog,
    toggleCompletedCourseDialog,
    openCompletedCourseDialog,
  }
  return (
    <SavedCoursesContext.Provider value={value}>
      {children}
    </SavedCoursesContext.Provider>
  )
}
